module.exports = __webpack_public_path__ + "static/img/KE@2x.4e112a12.jpg";